"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvatarText = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _helpers = require("../../helpers");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AvatarText = _styledComponents.default.div.withConfig({
  displayName: "AvatarText",
  componentId: "g0i7i6-0"
})(["color:", ";background:", ";border-radius:50%;width:40px;height:40px;line-height:40px;text-align:center;font-weight:500;margin-right:", ";flex-shrink:0;", ""], (0, _helpers.color)('white'), function (p) {
  return p.isSender ? (0, _helpers.color)('dark-1') : (0, _helpers.color)('primary');
}, (0, _helpers.getSpacing)('medium'), function (p) {
  return p.isReversed && (0, _styledComponents.css)(["color:", ";background:", ";"], (0, _helpers.color)('brand'), (0, _helpers.color)('white'));
});

exports.AvatarText = AvatarText;